(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["WISHLIST_HERO_BKP_header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.childNavlink = this.querySelectorAll('.list-child-meanu')
      this.navigation = this.querySelector('.stickyHeaderNav');
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
 
      this.childNavlink.forEach((elm)=>{
        elm.addEventListener('mouseenter',()=>{
          if( elm.querySelectorAll('.sub-menu').length ){
            elm.classList.add('active');
            document.querySelector('html').classList.add('js-html-active');
          }
        });
        elm.addEventListener('mouseleave',()=>{
          if( elm.querySelectorAll('.sub-menu').length ){
            elm.classList.remove('active');
            document.querySelector('html').classList.remove('js-html-active');
          }
        })        
      })
 
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
 
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
 
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
 
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
 
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
 
      this.createObserver();
    }
 
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
 
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
 
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
 
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
       if (scrollTop > 0) {
          this.header.classList.add('shopify-section-header-sticky');
        } else {
          this.header.classList.remove('shopify-section-header-sticky');
        }
       if (scrollTop > 100) {
          this.navigation.classList.add('active');
        } else {
          this.navigation.classList.remove('active');
        }      
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
      } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
 
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
 
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
 
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
 
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
 
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
 
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection_list_new"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
  var swiper = new Swiper('.swiper-container-list', {
    slidesPerView: 1.5,
    spaceBetween: 20,
    freeMode:true,
    loop: false,
    breakpoints: {
      750: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      1024: {
        slidesPerView: 3.5,
        spaceBetween: 20,
      },
    },
    navigation: {
      nextEl: '.slider-button--nexts',
      prevEl: '.slider-button--prevs',
    },
    pagination: {
      el: '.swiper-paginations',
      clickable: true,
    },
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection_slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const urlParams = new URLSearchParams(window.location.search);
    const currentType = urlParams.get("q");
    if (currentType) {
      const items = document.querySelectorAll(".collection-item");
      items.forEach(function (item) {
        const text = item.textContent.trim().toLowerCase().replace(/\s+/g, '-');
        const target = currentType.trim().toLowerCase().replace(/\s+/g, '-');
        if (text === target) {
          item.classList.add("active");
        } else{
          item.classList.remove("active"); 
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const element = document.querySelector('.stickyHeaderNav');
    window.addEventListener('scroll', function() {
      if (window.scrollY > 100) {
        element.classList.add('active');
      } else {
        element.classList.remove('active');
      }
    });
  });

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.childNavlink = this.querySelectorAll('.list-child-meanu')
      this.navigation = this.querySelector('.stickyHeaderNav');
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
 
      this.childNavlink.forEach((elm)=>{
        elm.addEventListener('mouseenter',()=>{
          if( elm.querySelectorAll('.sub-menu').length ){
            elm.classList.add('active');
            document.querySelector('html').classList.add('js-html-active');
          }
        });
        elm.addEventListener('mouseleave',()=>{
          if( elm.querySelectorAll('.sub-menu').length ){
            elm.classList.remove('active');
            document.querySelector('html').classList.remove('js-html-active');
          }
        })        
      })
 
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
 
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
 
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
 
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
 
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
 
      this.createObserver();
    }
 
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
 
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
 
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
 
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
       if (scrollTop > 0) {
          this.header.classList.add('shopify-section-header-sticky');
        } else {
          this.header.classList.remove('shopify-section-header-sticky');
        }
       if (scrollTop > 100) {
          this.navigation.classList.add('active');
        } else {
          this.navigation.classList.remove('active');
        }      
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
      } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
 
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
 
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
 
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
 
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
 
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
 
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab_section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
    let userInteracted = false;
    const tabLinks = document.querySelectorAll(".tablinks");
    const tabWrapper = document.querySelector(".tabs-wraperr");

    const swiper = new Swiper(".mySwiper", {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: false,
        navigation: false,
        pagination: false,
    });

    swiper.on("slideChangeTransitionStart", () => {
        userInteracted = true;
    });

    tabLinks.forEach((tab, index) => {
        tab.addEventListener("click", function () {
            userInteracted = true;
            if (!this.classList.contains("active")) {
                tabLinks.forEach(btn => btn.classList.remove("active"));
                this.classList.add("active");
                swiper.slideTo(index);
            }
        });
    });

    let prevIndex = swiper.activeIndex;

    function updateActiveTab(index) {
        tabLinks.forEach((tab, i) => {
            const isActive = i === index;
            if (tab.classList.contains("active") !== isActive) {
                tab.classList.toggle("active", isActive);
                if (isActive && userInteracted) {
                    tab.scrollIntoView({ behavior: "smooth", inline: "start", block: "nearest" });
                }
            }
        });
    }

    // Efficient slide change detection using rAF loop
    function watchSlideChange() {
        const currentIndex = swiper.activeIndex;
        if (currentIndex !== prevIndex) {
            prevIndex = currentIndex;
            updateActiveTab(currentIndex);
        }
        requestAnimationFrame(watchSlideChange);
    }

    updateActiveTab(prevIndex);
    requestAnimationFrame(watchSlideChange);
});


  } catch(e) { console.error(e); }
})();
})();
